<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-certificate fa-fw"></i>Certificados
          </h1>
          <div class="panel panel-default">
            <div class="panel-body">
              <form>
                <div class="form-group">
                  <input
                    v-model="search"
                    class="form-control"
                    placeholder="faça a busca por qualquer campo"
                    @keyup="buscar(search)"
                  />
                </div>
              </form>
            </div>
          </div>
          <div>
            <div v-if="certificates.length">
              <table class="table table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Certificado</th>
                    <th>Razão Social</th>
                    <th>Nome Fantasia</th>
                    <th>Atividade</th>
                    <th>Descrição</th>
                    <th>Emissão</th>
                    <th>Validade</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="certificate in filtred"
                    :key="certificate.id"
                    @mouseover="showByIndex = certificate.id"
                    @mouseout="showByIndex = null"
                     v-bind:class="certificate.validity >= dataAtual ? 'success' : 'danger'"
                  >
                    <td>{{ certificate.id }}</td>
                    <td>{{ certificate.processNumber }}</td>
                    <td>{{ certificate.person.name }}</td>
                    <td>{{ certificate.person.corporateName }}</td>
                    <td>{{ certificate.activity.name }}</td>
                    <td>{{ certificate.details }}</td>
                    <td>{{ certificate.created | formatDateMinimal }}</td>
                    <td>{{ certificate.validity | formatDateMinimal }}</td>
                    <td>
                      <a
                        v-bind:href="'/#/certificate/print/' + certificate.id"
                        target="_blank"
                        class="btn btn-sm btn-success"
                        v-visible="
                          showByIndex === certificate.id &&
                          certificate.validity >= dataAtual
                        "
                      >
                        <i class="fa fa-download"></i>
                      </a>
                      <a
                        v-if="canDeleteCertificate()"
                        class="btn btn-sm btn-danger"
                        v-visible="showByIndex === certificate.id"
                        @click="
                          showModal = 2;
                          show = showByIndex;
                        "
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                      <Modal v-if="showModal === 2 && show === certificate.id">
                        <i
                          slot="close"
                          @click="
                            showModal = null;
                            yes = null;
                          "
                          >&times;</i
                        >
                        <h2 slot="header">
                          <i class="fa fa-times fa-fw"></i>Remover Certificado
                        </h2>
                        <div slot="body">
                          <h4>
                            <p>
                              Deseja realmente remover o certificado da empresa:
                            </p>
                            <p>
                              <strong>{{ certificate.person.name }}</strong>
                            </p>
                            <p>para a atividade:</p>
                            <p>
                              <strong>{{ certificate.activity.name }}</strong>
                            </p>
                          </h4>
                        </div>
                        <div slot="footer">
                          <button
                            type="button"
                            class="btn btn-primary"
                            @click="
                              yes = true;
                              showModal = null;
                            "
                            @click.stop="remove(certificate.id)"
                          >
                            Confirmar
                          </button>
                          <button
                            class="btn btn-default"
                            @click="
                              yes = null;
                              showModal = null;
                            "
                          >
                            Fechar
                          </button>
                        </div>
                      </Modal>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else-if="!certificates.length">
              <div class="alert alert-info">
                <p>
                  <i class="fa fa-exclamation fa-fw"></i>
                  Nenhum certificado foi encontrado
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storage from "../../mixins/storage";
import Modal from "../ui-elements/Modal.vue";

export default {
  name: "Certificate",
  components: { Modal },
  inject: ["loading"],
  data() {
    return {
      search: '',
      config: {},
      certificate: {},
      certificates: [],
      user: {},
      users: [],
      sector: {},
      sectors: [],
      showByIndex: null,
      show: null,
      yes: null,
      showModal: null,
      server: {
        url: this.$http.defaults.baseURL,
        process: {
          url: "/config/download",
          method: "GET",
          withCredentials: false,
          headers: {
            Authorization: `Bearer ${storage.methods.getToken()}`,
          },
          timeout: 7000,
          onload: null,
          onerror: null,
          ondata: null,
        },
      },
    };
  },
  mounted() {
    this.buscar();
  },

  methods: {
    buscar() {

      this.$http.get('certificate/all').then((response) => {
        this.certificates = response.data;

        this.$http.get('/config').then((response) => {
          this.config = response.data;
        });
        
        this.$http
          .get(`/auth/info/${storage.methods.getToken()}`)
          .then((response) => {
            this.user = response.data;
          });
      });
    },
    canDeleteCertificate() {
      return this.config.sectorId == this.user.sectorId;
    },
    remove(id) {
      this.loading.value = true;
      const confirm = this.yes;

      if (confirm) {
        this.$http
          .delete(`/certificate/${id}`)
          .then((response) => {
            this.certificates = this.certificates.filter(
              (item) => item.id != id
            );
            this.showModal = 2;
          })
          .catch((error) => alert(error));
      }

      setTimeout(() => (this.loading.value = false), 1000);
    },
    // consoleCertificates() {
      // for (let i = 0; i < this.certificates.length; i++) {
        // console.log(certificates[0]);
      // }
    // },
  },

  computed: {
    dataAtual() {
      const date = new Date();
      return date.toISOString();
    },
    filtred() {
      const search = this.search.toLowerCase().trim()
      let result = []

      if (!search) {
        result = this.certificates;
        return result;
      }

      result =  this.certificates.filter( certificate => {

          const name = certificate.person.name || ''
          const corporateName = certificate.person.corporateName || ''
          const processNumber = certificate.processNumber || ''
          const activityName = certificate.activity.name || ''
          const certificateDetails = certificate.details || ''
          const validity = certificate.validity || ''

          return  name.toLowerCase().indexOf(search) > - 1 || 
                  corporateName.toLowerCase().indexOf(search) > -1 ||
                  processNumber.toLowerCase().indexOf(search) > -1 ||
                  activityName.toLowerCase().indexOf(search) > -1 ||
                  certificateDetails.toLowerCase().indexOf(search) > -1 ||
                  validity.toLowerCase().indexOf(search) > -1
        })


      return result.sort((a, b) => b.id - a.id);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Certificates.vue